import styled from "styled-components";

export const Container = styled.div `

    padding: 10px 30px 30px 30px;
    
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    header h2 {
        margin: 0 !important;
    }
    
    header div {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    header button {
        background: unset;
        color: #fff;
        height: 40px;
        width: 40px;
        border-radius: 50px;
        border: none;
        cursor: pointer;
        font-size: 1.1rem;
        transition: all .3s ease;
    }

    header button:hover {
        background: #303030;
    }

    header button:first-child {
        margin-right: 5px;
    }

    header .active {
        background: #fff;
        color: #181818;
    }

    header .active:hover {
        cursor: default;
        background: #fff;
    }

    .container-episodes {
        display: ${props => props.layoutStyle == 'grid' ? 'grid' : 'flex'};
        flex-direction: column;
        grid-template-columns: repeat(3, 1fr);
        gap:  ${props => props.layoutStyle == 'grid' ? '10px' : '0'};
    }

    .episode {
        display: ${props => props.layoutStyle == 'grid' ? 'block' : 'flex'};
        color: #fff;
        padding: ${props => props.layoutStyle == 'grid' ? '10px' : '30px 10px'};
        border-bottom: ${props => props.layoutStyle == 'grid' ? 'none' : '2px solid #505050'};
        border-radius: 5px;
        transition: all .3s ease;
    }

    .episode:hover {
        background: #303030;
    }

    .episode .has-image {
        border-radius: 5px;
        max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
        width: 100%;
        height: auto;
        background-color: #252525;
        aspect-ratio: 16/10;
        object-fit: cover;
    }

    .episode .no-image {
        border-radius: 5px;
        max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
        padding: 50px;
        width: 100%;
        background-color: #353535;
        aspect-ratio: 16/10;
        object-fit: contain;
    }

    .episode .details {
        margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
    }

    .episode .details .name {
        font-size: 1.1rem;
        overflow: hidden;
        font-weight: bold;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .episode .details section {
        margin: 5px 0 10px 0;
    }

    .episode .details section span {
        margin-right: 10px;
        font-size: .85rem;
        font-weight: 600;
        color: #bbb;
    }

    .episode .details .name span {
        margin-right: 10px;
    }

    .episode .details .overview {
        font-size: .85rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        color: #ccc;
        -webkit-box-orient: vertical;
    }

    
    .section-more-movies {
        background-image: linear-gradient(0deg, #252525, #252525e0, #20202000);
        display: flex;
        justify-content: center;
        margin-top: -200px;
        padding: 100px 0 60px 0;
        position: relative;
        z-index: 2;
        
    }

    .section-more-movies button {
        background: #181818b3;
        color: #fff;
        align-items: center;
        border: 2px solid #aaa;
        border-radius: 50px;
        cursor: pointer;
        display: flex;
        height: 38px;
        justify-content: center;
        margin-right: 10px;
        transition: all .2s ease;
        width: 38px;
    }

    .section-more-movies button:hover {
        background: #404040;
        border: 2px solid #fff;
    }


    @media (max-width: 1000px) {

        .container-episodes {
            grid-template-columns: repeat(2, 1fr);
        }

        .episode {
            padding: ${props => props.layoutStyle == 'grid' ? '10px' : '20px 5px'};
        }

        .episode .has-image, .episode .no-image {
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '180px'};
        }

        .episode .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
        }

        .episode .details .name {
            font-size: 1rem;
        }

        .episode .details section span {
            font-size: .7rem;
        }

        .episode .details .overview {
            font-size: .75rem;
        }

        .episode .no-image {
            padding: 30px;
        }

    }

    @media (max-width: 800px) {

        .episode .has-image, .episode .no-image {
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '170px'};
        }

        .episode .details .name {
            margin-top: 0 !important;
        }

        .episode .no-image {
            padding: 25px;
        }

    }

    @media (max-width: 600px) {

        padding: 10px 18px 30px 18px;

        header button {
            height: 30px;
            width: 30px;
            font-size: .9rem;
        }

        .episode {
            padding: ${props => props.layoutStyle == 'grid' ? '10px' : '20px 5px'};
        }

        .episode .has-image, .episode .no-image {
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '150px'};
        }

        .episode .no-image {
            padding: 20px;
        }

        .episode .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
        }

        .episode .details .name {
            font-size: .85rem;
        }

        .episode .details section span {
            font-size: .65rem;
        }

        .episode .details .overview {
            font-size: .65rem;
        }

    }

    @media (max-width: 550px) {

        .container-episodes {
            grid-template-columns: repeat(1, 1fr);
            gap:  ${props => props.layoutStyle == 'grid' ? '5px' : '0'};
        }

        .episode {
            padding: ${props => props.layoutStyle == 'grid' ? '5px' : '15px 5px'};
        }

        .episode .has-image, .episode .no-image {
            aspect-ratio: 16/9;
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '140px'};
        }

        .episode .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '10px'};
        }

        .episode .details .name {
            font-size: .8rem;
        }

        .episode .details section {
            margin: 0 0 5px 0;
        }

        .episode .details section span {
            font-size: .6rem;
        }

        .episode .details .overview {
            font-size: .6rem;
        }

    }

`